import { useNavigate } from 'react-router';
import { IconButton } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import useBreakpoints from '../../hooks/useBreakpoints';
import UnreadMessagesBadge from './UnreadMessagesBadge';

const style = {
  profileButton: {
    backgroundColor: 'neutral.700',
    color: 'neutral.300',
    p: { xs: 0.75, md: 1 },
  },
};
const ProfileButton = () => {
  const navigate = useNavigate();
  const { isMobile } = useBreakpoints();

  const handleClick = () => {
    navigate('/profile');
  };

  return (
    <IconButton onClick={handleClick} sx={style.profileButton}>
      <UnreadMessagesBadge>
        <AccountCircle fontSize={isMobile ? 'medium' : 'large'} />
      </UnreadMessagesBadge>
    </IconButton>
  );
};

export default ProfileButton;
